export default "__VITE_ASSET__BQksC1Oj__"